import { render, staticRenderFns } from "./orbit-edit.vue?vue&type=template&id=3c6ee06c&"
import script from "./orbit-edit.vue?vue&type=script&lang=js&"
export * from "./orbit-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports